// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2CHK1","right":"styles_right__2yGgC"};